<template>
  <div>
    <slot v-if="!isLocked" />
    <div v-else class="block block-rounded text-center py-6">
      <premium-icon class="feature-gate-icon mb-4" />
      <h3 class="mb-2">{{ $t('featureGate.title') }}</h3>
      <p class="text-muted mb-4">{{ $t('featureGate.not_available') }}</p>
    </div>
  </div>
</template>

<script>
import PremiumIcon from '@/components/svg/PremiumIcon.vue'

export default {
  components: { PremiumIcon },
  props: {
    feature: {
      type: String,
      required: true
    }
  },
  computed: {
    isLocked () {
      return this.$store.getters.disabledFeatures.includes(this.feature)
    },
    currentClient () {
      return this.$store.state.currentClient
    }
  }
}
</script>

<style scoped>
.feature-gate-icon {
  height: 48px;
  display: block;
  margin: 0 auto;
}
</style>
